export const catalogMat = Signalman.featureFlag('catalog_mat');
export const subcatNav = Signalman.featureFlag('subcat_nav2_v2');
export const subcatRedesign = Signalman.featureFlag('subcat_redesign_v2');
export const pricingOnPDP = Signalman.featureFlag('pricing_on_pdp_test_v6');
// prettier-ignore
export const newPricingDetails = Signalman.featureFlag('plp_pricing_details_v0');
export const previewUpload = Signalman.featureFlag('preview_upload_v7');
